<div class="mark-as-status-modal" *ngIf="iStatusForm">
  <snl-modal  [type]="'medium'" [open]="iStatusForm" [settings]="setting">
    <div slot="heading">
      <ng-container *ngIf="shipDetail.iActive; else inActive">Mark as Inactive</ng-container>
      <ng-template #inActive>Mark as Active</ng-template>
    </div>
    <div slot="headingDescription">
      <span class="text d-flex">
        <span class="d-flex container-c-bx col-gap-8">
          Ship : 
          <span class="ShipsPillsMain fw-700 CommonPillsMain color__primary d-flex"> 
            <span class="truncate-txt single-line ship-name"> {{shipDetail.vslName}}</span>
            <span class="ShipNumberPills CommonPills fw-400 labels d-flex align-items-center">{{shipDetail.vslNumber}} </span>
          </span>
        </span>
       </span>
    </div>
    <div slot="modalContent">
      <form [formGroup]="statusForm">

        <div class="d-flex effectiveDiv">
          <div class="effectiveDate half-containers">
            <snl-input class="datepicker" snlDatePicker [min]="minDate" placeholder="input" label="Effective Date" placeholder="input"  formControlName="effectiveDate"  [isError]="(statusForm.controls['effectiveDate'].hasError('required') && submit )" [value]="statusForm.value.effectiveDate"  (selectedDate) = selectedDate($event) [isTrailingIconDisplayed]="true" trailingIcon="fa-calendar far"></snl-input>
          </div>
          <div class="half-containers"></div>
       </div>
       <div class="reason">
          <snl-input label='Reason' formControlName="resion"  placeholder="input" [isError]="(statusForm.controls['resion'].hasError('required') && submit)" [value]="statusForm.value.resion"></snl-input>
        </div>
      </form>
    </div>
    <div slot="modalFooter">
      <snl-button size="small" (buttonClick)="saveStatus()">Save</snl-button>
      <snl-button size="small" type="secondary" (buttonClick)="closePopup()">Cancel</snl-button>
    </div>
</snl-modal>
</div>
